@switch (state) {
  @case ('loading') {
    <main class="status-screen">
      <div class="status-content">
        <div class="cl-spinner">Loading report...<i class="fas fa-spinner fa-spin"></i></div>
      </div>
    </main>
  }
  @case ('no-data') {
    <main class="status-screen">
      <div class="status-content">
        <span>There are no reports available.<br/>Not all delivery destinations support reports yet.</span>
      </div>
    </main>
  }
  @case ('error') {
    <main class="status-screen">
      <div class="status-content">
        <span class="alert cl-alert-error">{{ errorMessage }}</span>
      </div>
    </main>
  }
  @case ('ready') {
    <div class="report-actions print-hide">
      <button class="btn cl-btn-primary" (click)="printPage()">
        <span>Print</span> <i class="fas fa-print"></i>
      </button>
    </div>
    <div class="report-container" [innerHTML]="reportHtml"></div>
  }
}

<app-auto-logout></app-auto-logout>
